import { CanConsumptionMessages, TranslationCanConsumptionMessages } from "../interfaces/canConsumptionMessages";

const canConsumptionMessages: TranslationCanConsumptionMessages = {
  [CanConsumptionMessages.menu]: "CAN telemetry",
  [CanConsumptionMessages.title]: "CAN telemetry",
  [CanConsumptionMessages.tabDashboard]: "Dashboard",
  [CanConsumptionMessages.tabSyntheticReport]: "Synthetic report",
  [CanConsumptionMessages.tabAnalyticReport]: "Analytic report",
  [CanConsumptionMessages.tabGraph]: "CAN graph",

  [CanConsumptionMessages.volumeCarriedColumn]: "Volume Carried (m³)",

  [CanConsumptionMessages.filterPeriod]: "Analysis period",
  [CanConsumptionMessages.filterPreset7Days]: "Last 7 days",
  [CanConsumptionMessages.filterPreset3Days]: "Last 3 days",
  [CanConsumptionMessages.filterPreset1Day]: "Last day",
  [CanConsumptionMessages.filterPresetCustom]: "Custom",
  [CanConsumptionMessages.filterDateFrom]: "From",
  [CanConsumptionMessages.filterDateTo]: "to",
  [CanConsumptionMessages.filterPlants]: "Plant",
  [CanConsumptionMessages.filterVehicleTypes]: "Equipment type",
  [CanConsumptionMessages.filterAllVehicleTypes]: "All",
  [CanConsumptionMessages.filterAlertLimits]: "Alert limits",
  [CanConsumptionMessages.filterPlantsPlural]: "Plants",
  [CanConsumptionMessages.filterVehicleTypesPlural]: "Equipment types",

  [CanConsumptionMessages.periodSummary]: "{{vehicles}} equipment · {{travels}} travels",
  [CanConsumptionMessages.periodConsolidatingWarning]:
    "The period ends on days that are still consolidating: invoice integration takes 1 to 2 days, so the volume of those days may still rise.",
  [CanConsumptionMessages.periodNoData]: "No consumption data for the selected period and filters.",

  [CanConsumptionMessages.metricLitersPerM3Label]: "Average consumption per m³",
  [CanConsumptionMessages.metricLitersPerM3Short]: "Consumption per m³",
  [CanConsumptionMessages.metricLitersPerM3Unit]: "L/m³",
  [CanConsumptionMessages.metricKmPerLiterLabel]: "Kilometers per liter",
  [CanConsumptionMessages.metricKmPerLiterShort]: "Km per liter",
  [CanConsumptionMessages.metricKmPerLiterUnit]: "km/L",
  [CanConsumptionMessages.metricLitersPerTravelLabel]: "Average consumption per travel",
  [CanConsumptionMessages.metricLitersPerTravelShort]: "Consumption per travel",
  [CanConsumptionMessages.metricLitersPerTravelUnit]: "L/travel",
  [CanConsumptionMessages.metricLitersPerHourLabel]: "Average consumption per hour",
  [CanConsumptionMessages.metricLitersPerHourShort]: "Consumption per hour",
  [CanConsumptionMessages.metricLitersPerHourUnit]: "L/h",
  [CanConsumptionMessages.metricIdleLitersPerHourLabel]: "Idle",
  [CanConsumptionMessages.metricIdleLitersPerHourShort]: "Idle",
  [CanConsumptionMessages.metricIdleLitersPerHourUnit]: "L/h",
  [CanConsumptionMessages.hintLowerIsBetter]: "the lower, the better",
  [CanConsumptionMessages.hintHigherIsBetter]: "the higher, the better",

  [CanConsumptionMessages.zoneOk]: "within the limit",
  [CanConsumptionMessages.zoneWarn]: "in the warning band",
  [CanConsumptionMessages.zoneCritical]: "above the critical limit",
  [CanConsumptionMessages.gaugeThresholds]: "warning {{warn}} · critical {{critical}}",
  [CanConsumptionMessages.gaugeNoData]: "no data in the current filter",

  [CanConsumptionMessages.tileVolume]: "Volume carried",
  [CanConsumptionMessages.tileVolumeFoot]: "{{travels}} travels in the period",
  [CanConsumptionMessages.tileFuel]: "Fuel consumed",
  [CanConsumptionMessages.tileFuelFoot]: "{{distance}} km traveled",
  [CanConsumptionMessages.tileFuelInside]: "Fuel inside travels",
  [CanConsumptionMessages.tileFuelInsideFoot]: "{{percent}}% of the total",
  [CanConsumptionMessages.tileFuelBetween]: "Fuel between travels",
  [CanConsumptionMessages.tileFuelBetweenFoot]: "all consumption outside the travels · {{percent}}% of the total",
  [CanConsumptionMessages.tileFuelBetweenHint]: "Measured by the vehicle's own counter, from the end of one travel to "
    + "the start of the next — with no filter of location or speed. Everything burned outside the travels counts: "
    + "idling and waiting in the yard, the empty return, refuelling, maintenance and any other displacement. Under a "
    + "plant filter, each gap is charged to the plant of the next travel.",
  [CanConsumptionMessages.tileHoursBetween]: "Engine running between travels",
  [CanConsumptionMessages.tileHoursBetweenFoot]: "{{idle}} at idle",
  [CanConsumptionMessages.tileHoursBetweenHint]: "Time with the engine running outside the travels — the ruler "
    + "for the litres beside it. Zero here is a measurement, not an absence: it means the fleet shut the engine "
    + "off in the yard.",
  [CanConsumptionMessages.tileAvgKmPerTravel]: "Average distance per travel",
  [CanConsumptionMessages.tileAvgKmPerTravelFoot]: "CAN odometer of the period travels",
  [CanConsumptionMessages.tileAvgSpeed]: "Average speed",
  [CanConsumptionMessages.tileAvgSpeedFoot]: "weighted by travel",
  [CanConsumptionMessages.tileAvgTravelTime]: "Average time per travel",
  [CanConsumptionMessages.tileAvgTravelTimeFoot]: "from leaving the plant to the end of the travel",
  [CanConsumptionMessages.tileAttention]: "Equipment needing attention",
  [CanConsumptionMessages.tileAttentionFoot]: "above the {{metric}} limit",

  [CanConsumptionMessages.rankingTitle]: "Ranking by vehicle",
  [CanConsumptionMessages.rankingSubtitle]: "Each bar is a vehicle. The line marks the fleet median.",
  [CanConsumptionMessages.rankingMetricLabel]: "Ranking indicator",
  [CanConsumptionMessages.rankingFallbackNote]: "no {{metric}} data in this filter — showing {{fallback}}",
  [CanConsumptionMessages.rankingEmpty]: "No {{metric}} data for the current filter.",

  [CanConsumptionMessages.dailyTitle]: "Day by day",
  [CanConsumptionMessages.dailySubtitle]: "Volume carried per day and the matching average consumption.",
  [CanConsumptionMessages.dailyFoot]: "Bars: {{bars}} · numbers: {{metric}} ({{unit}})",
  [CanConsumptionMessages.dailyBarsVolume]: "volume carried (m³)",
  [CanConsumptionMessages.dailyBarsFuel]: "fuel (L)",
  [CanConsumptionMessages.dailyNoOperation]: "no operation",
  [CanConsumptionMessages.dailyConsolidating]: "still consolidating",
  [CanConsumptionMessages.dailyConsolidatingLegend]:
    "Hatched day: still consolidating. Invoice integration takes 1 to 2 days, so the volume of the day may still rise and consumption per m³ "
    + "looks inflated.",

  [CanConsumptionMessages.plantsTitle]: "Consumption per plant",
  [CanConsumptionMessages.plantsSubtitle]:
    "Every travel belongs to the plant it loaded at, or to the plant the vehicle is allocated to when it did not leave a plant. "
    + "The fuel between travels follows the next travel.",
  [CanConsumptionMessages.plantsNoPlantRow]: "No plant",
  [CanConsumptionMessages.columnPlant]: "Plant",

  [CanConsumptionMessages.tableTitle]: "Performance by vehicle",
  [CanConsumptionMessages.columnVehicle]: "Vehicle",
  [CanConsumptionMessages.columnVehicleType]: "Type",
  [CanConsumptionMessages.columnPlants]: "Plants",
  [CanConsumptionMessages.columnTravels]: "Travels",
  [CanConsumptionMessages.columnVolume]: "Volume carried (m³)",
  [CanConsumptionMessages.columnDistance]: "Distance (km)",
  [CanConsumptionMessages.columnFuel]: "Fuel (L)",
  [CanConsumptionMessages.columnAvgKmPerTravel]: "Average distance (km/travel)",
  [CanConsumptionMessages.columnAvgSpeed]: "Average speed (km/h)",
  [CanConsumptionMessages.columnAvgTravelTime]: "Average time (h:mm)",
  [CanConsumptionMessages.tableLowSample]: "few travels",
  [CanConsumptionMessages.tableEmpty]: "No equipment for the selected period and filters.",
  [CanConsumptionMessages.legendBest]: "Best",
  [CanConsumptionMessages.legendWorst]: "Worst",
  [CanConsumptionMessages.legendHigherIsBetter]: "In km per liter, the higher the number, the better.",
  [CanConsumptionMessages.legendNoColor]:
    "Cell without color: no data in the period or fewer than {{minTravels}} travels — a small basis does not enter ranking or alerts.",

  [CanConsumptionMessages.limitsTitle]: "Alert limits",
  [CanConsumptionMessages.limitsSubtitle]:
    "Set, for each indicator, the value from which a vehicle deserves attention. The gauge bands and the table colors follow these limits.",
  [CanConsumptionMessages.limitsWarn]: "Warning",
  [CanConsumptionMessages.limitsCritical]: "Critical",
  [CanConsumptionMessages.limitsFleetMedian]: "fleet median {{value}}",
  [CanConsumptionMessages.limitsReset]: "Restore defaults",
  [CanConsumptionMessages.limitsDone]: "Done",
  [CanConsumptionMessages.limitsClose]: "Close"
};

export const messages = canConsumptionMessages;
